import { Phase } from '@/features/orders/constants/app'
import { Order } from '@/features/orders/types/app'
import { UuidOrderMap } from '@/redux/reducers/orders/types'
import dayjs from 'dayjs'

type GetOrderSortPropertyCallback = (order: Order) => string | undefined
type SortOrder = 'desc' | 'asc'

const sortOrderUuidsByDateTimeProperty = (
    uuidOrderMap: UuidOrderMap,
    uuids: string[],
    getOrderSortPropertyCallback: GetOrderSortPropertyCallback,
    sortOrder: SortOrder = 'asc'
) =>
    uuids.sort((a, b) => {
        const orderA = uuidOrderMap[a]
        const orderB = uuidOrderMap[b]

        if (!orderA || !orderB) {
            return 0
        }

        const propertyA = getOrderSortPropertyCallback(orderA)
        const propertyB = getOrderSortPropertyCallback(orderB)

        if (!propertyA || !propertyB) {
            return 0
        }

        if (propertyA === propertyB) {
            return dayjs(orderA.createdAt).isAfter(dayjs(orderB.createdAt)) ? -1 : 1
        }

        const propertyADayjs = dayjs(propertyA)
        const propertyBDayjs = dayjs(propertyB)

        if (sortOrder === 'asc') {
            return propertyADayjs.isAfter(propertyBDayjs) ? 1 : -1
        }

        return propertyADayjs.isAfter(propertyBDayjs) ? -1 : 1
    })

export const sortOrderUuids = (uuids: string[], uuidOrderMap: UuidOrderMap, phase: Phase) => {
    return sortOrderUuidsByDateTimeProperty(
        uuidOrderMap,
        uuids,
        (order) => getOrderSortProperty(order),
        phase === Phase.New || phase === Phase.Archived ? 'desc' : 'asc'
    )
}

export const getOrderSortProperty = (order: Order) => {
    switch (order.phase) {
        case Phase.New:
            return order.createdAt
        case Phase.InProgress:
            return order.acceptedDeliveryTime?.end
        case Phase.Future:
            return order.remindAt
        case Phase.Archived:
            return order.deliveredAt ?? order.createdAt
    }
}
